import { useTranslation } from 'react-i18next';
import { cn } from '@core/utils/cn';
import { Spinner } from './Spinner';

interface LoadingStateProps {
  readonly label?: string;
  readonly className?: string;
  readonly fullscreen?: boolean;
}

/** Generic centered loading indicator (prefer skeletons for list layouts). */
export function LoadingState({
  label,
  className,
  fullscreen = false,
}: LoadingStateProps): React.JSX.Element {
  const { t } = useTranslation();
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-3 text-muted',
        fullscreen ? 'min-h-[60vh]' : 'py-16',
        className,
      )}
    >
      <Spinner size={28} className="text-accent" label={label ?? t('common.loading')} />
      <p className="text-sm">{label ?? t('common.loading')}</p>
    </div>
  );
}
